import React from 'react';
import { Award, GraduationCap, Heart } from 'lucide-react';
export function PhysicianProfileKhan() {
  return <div className="min-h-screen bg-gradient-to-b from-white to-[#f8faff] dark:from-[#0a0e17] dark:to-[#111827]" data-id="element-915">
      {/* Hero Section */}
      <section className="pt-32 pb-16 px-6" data-id="element-916">
        <div className="container mx-auto max-w-6xl" data-id="element-917">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-918">
            {/* Image */}
            <div className="flex justify-center" data-id="element-919">
              <div className="relative" data-id="element-920">
                <div className="absolute inset-0 bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] rounded-2xl blur-2xl opacity-20" data-id="element-921"></div>
                <img src="https://cdn.magicpatterns.com/uploads/4n1TAq22HpTbKuJuZw3PEu/nm4ua0V7.jpg" alt="Dr. Aliya Khan" className="relative rounded-2xl shadow-2xl w-full max-w-md" data-id="element-922" />
              </div>
            </div>

            {/* Info */}
            <div data-id="element-923">
              <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-924">
                <span className="bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] bg-clip-text text-transparent" data-id="element-925">
                  Dr. Aliya Khan, MD
                </span>
              </h1>
              <p className="text-xl text-gray-600 dark:text-gray-300 mb-6" data-id="element-926">
                Board Certified Internal Medicine & Obesity Medicine Physician
              </p>
              <div className="flex items-center gap-2 text-gray-600 dark:text-gray-400 mb-8" data-id="element-927">
                <Heart className="text-[#C85A15]" size={20} data-id="element-928" />
                <span data-id="element-929">20+ years of comprehensive, patient-centered care</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bio Section */}
      <section className="py-16 px-6" data-id="element-930">
        <div className="container mx-auto max-w-4xl" data-id="element-931">
          <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-10 shadow-xl border border-white/20 dark:border-gray-700/30" data-id="element-932">
            <div className="flex items-center gap-3 mb-6" data-id="element-933">
              <div className="w-12 h-12 rounded-full bg-[#C85A15]/20 flex items-center justify-center" data-id="element-934">
                <Heart className="text-[#C85A15]" size={24} data-id="element-935" />
              </div>
              <h2 className="text-3xl font-bold" data-id="element-936">About Dr. Khan</h2>
            </div>
            <div className="space-y-4 text-gray-600 dark:text-gray-300 text-lg leading-relaxed" data-id="element-937">
              <p data-id="element-938">
                Dr. Aliya Khan is a distinguished Internal Medicine Physician
                with over 20 years of clinical experience dedicated to providing
                comprehensive, patient-centered care. With advanced training in
                the complex science of weight management, Double Board
                Certifications in Obesity Medicine as well as Internal Medicine,
                Dr. Khan integrates medical expertise, nutritional guidance, and
                behavioral strategies to help patients achieve sustainable
                health outcomes.
              </p>
            </div>
          </div>

          {/* Certifications Section */}
          <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-10 shadow-xl border border-white/20 dark:border-gray-700/30 mt-8" data-id="element-939">
            <div className="flex items-center gap-3 mb-8" data-id="element-940">
              <div className="w-12 h-12 rounded-full bg-[#BBDDFF]/20 flex items-center justify-center" data-id="element-941">
                <Award className="text-[#BBDDFF]" size={24} data-id="element-942" />
              </div>
              <h2 className="text-3xl font-bold" data-id="element-943">Board Certifications</h2>
            </div>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-944">
              <div className="flex items-start gap-3" data-id="element-945">
                <Award className="text-[#C85A15] flex-shrink-0 mt-1" size={20} data-id="element-946" />
                <div data-id="element-947">
                  <h3 className="font-semibold mb-1" data-id="element-948">Board Certified</h3>
                  <p className="text-gray-600 dark:text-gray-300" data-id="element-949">
                    Internal Medicine
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-950">
                <Award className="text-[#C85A15] flex-shrink-0 mt-1" size={20} data-id="element-951" />
                <div data-id="element-952">
                  <h3 className="font-semibold mb-1" data-id="element-953">Board Certified</h3>
                  <p className="text-gray-600 dark:text-gray-300" data-id="element-954">
                    Obesity Medicine
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Areas of Expertise */}
          <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-10 shadow-xl border border-white/20 dark:border-gray-700/30 mt-8" data-id="element-955">
            <div className="flex items-center gap-3 mb-8" data-id="element-956">
              <div className="w-12 h-12 rounded-full bg-[#BBDDFF]/20 flex items-center justify-center" data-id="element-957">
                <GraduationCap className="text-[#BBDDFF]" size={24} data-id="element-958" />
              </div>
              <h2 className="text-3xl font-bold" data-id="element-959">Areas of Expertise</h2>
            </div>
            <div className="space-y-4" data-id="element-960">
              <div className="flex items-center gap-3" data-id="element-961">
                <div className="w-2 h-2 rounded-full bg-[#C85A15]" data-id="element-962"></div>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-963">
                  <span className="font-semibold" data-id="element-964">Weight Management</span> –
                  Advanced training in the complex science of sustainable weight
                  loss
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-965">
                <div className="w-2 h-2 rounded-full bg-[#C85A15]" data-id="element-966"></div>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-967">
                  <span className="font-semibold" data-id="element-968">Medical Expertise</span> –
                  Comprehensive internal medicine care
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-969">
                <div className="w-2 h-2 rounded-full bg-[#C85A15]" data-id="element-970"></div>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-971">
                  <span className="font-semibold" data-id="element-972">Nutritional Guidance</span> –
                  Evidence-based dietary strategies
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-973">
                <div className="w-2 h-2 rounded-full bg-[#C85A15]" data-id="element-974"></div>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-975">
                  <span className="font-semibold" data-id="element-976">Behavioral Strategies</span> –
                  Integrated approach to sustainable health outcomes
                </p>
              </div>
            </div>
          </div>

          {/* Licensed States */}
          <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-10 shadow-xl border border-white/20 dark:border-gray-700/30 mt-8" data-id="element-977">
            <div className="flex items-center gap-3 mb-8" data-id="element-978">
              <div className="w-12 h-12 rounded-full bg-[#C85A15]/20 flex items-center justify-center" data-id="element-979">
                <Award className="text-[#C85A15]" size={24} data-id="element-980" />
              </div>
              <h2 className="text-3xl font-bold" data-id="element-981">Licensed in 5 States</h2>
            </div>
            <div className="flex flex-wrap gap-3" data-id="element-982">
              {['NJ', 'PA', 'MD', 'TX', 'FL'].map(state => <span key={state} className="bg-gradient-to-r from-[#BBDDFF]/20 to-[#C85A15]/20 px-4 py-2 rounded-full font-semibold" data-id="element-983">
                  {state}
                </span>)}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-6" data-id="element-984">
        <div className="container mx-auto max-w-4xl text-center" data-id="element-985">
          <div className="bg-gradient-to-r from-[#BBDDFF]/10 to-[#C85A15]/10 rounded-2xl p-12 border border-white/20 dark:border-gray-700/30" data-id="element-986">
            <h2 className="text-3xl font-bold mb-4" data-id="element-987">
              Ready to Start Your Journey?
            </h2>
            <p className="text-lg text-gray-600 dark:text-gray-300 mb-8" data-id="element-988">
              Dr. Khan is here to support you with personalized care tailored to
              your needs.
            </p>
            <a href="https://app.joinomu.com/patient/onboarding" target="_blank" rel="noopener noreferrer" className="inline-flex items-center bg-gradient-to-r from-[#C85A15] to-[#FF8A3D] text-white font-medium py-3 px-8 rounded-full hover:shadow-lg transition-all" data-id="element-989">
              Get Started Today
            </a>
          </div>
        </div>
      </section>
    </div>;
}